import QuickDepositSuccess from './QuickDepositSuccess';

export default QuickDepositSuccess;
